module.exports = __webpack_public_path__ + "img/niews-5.2b219f16.jpeg";